jQuery( document ).ready(function() {
    let elements = document.querySelectorAll('.ingredients-slider-swiper');

    for (i = 0; i < elements.length; i++) {
        elements[i].classList.add(`swiper-${i}`);

        new Swiper(`.swiper-${i}`, {
            slidesPerView: 1,
            spaceBetween: 100,
            navigation: {
                nextEl: elements[i].parentNode.querySelector(".swiper-button-next"),
                prevEl: elements[i].parentNode.querySelector(".swiper-button-prev"),
            },
            simulateTouch: false
        });
    }
})